import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  switchWrapper: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "16px 0",
    "& .MuiTypography-root": {
      fontFamily: "'Inter', sans-serif !important",
      fontWeight: "600 !important",
      color: "#0f172a",
    },
  },
  divider: {
    "& .MuiDivider-root": {
      borderColor: "#f1f5f9",
    },
  },
  noteText: {
    color: "#64748b !important",
    fontStyle: "italic",
    fontFamily: "'Inter', sans-serif !important",
    fontSize: "14px !important",
  },
}));

export default useStyles;
